import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
// import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Lottie from 'lottie-react';
import { getAnimationIcon } from '../utils/utils';
import ButtonGeneral from '../components/buttons/ButtonGeneral';

const targetId = 'confirm-alert-on';

interface ButtonProps {
    confirmButton?: any;
    cancelButton?: any;
    updateButton?: any;
}

interface RequestConfirmationProps {
    title: string;
    message: string;
    message_list?: string[];
    buttons?: ButtonProps;
    onClickOutsideFunction?: () => void;
    customComponent?: React.ReactNode;
}

interface AlertNotificationTypeProps {
    title: string;
    message: string;
    confirmButtonText?: string;
    icon?: string;
    message_list?: string[];
    customComponent?: (onClose: () => void) => React.ReactNode;
    useHTML?: boolean; // Si es true, renderiza message como HTML
}

const addBodyClass = () => {
    const confirmAlertOne = document.getElementById('confirm-alert-on');
    confirmAlertOne?.classList.add('confirm-alert-all');
    // document.body.classList.add('react-confirm-alert-body-element');
};

const removeBodyClass = () => {
    const confirmAlertOne = document.getElementById('confirm-alert-on');
    confirmAlertOne?.classList.remove('confirm-alert-all');
    // document.body.classList.remove('react-confirm-alert-body-element');
};

const useReactConfirmAlert = () => {
    const requestConfirmation = ({
        title = '¿Estás seguro?',
        message = 'Confirme para continuar',
        message_list = [],
        buttons = {
            confirmButton: {
                label: 'Si',
                onClick: () => {
                    return;
                }
            },

            cancelButton: {
                label: 'No',
                onClick: () => {
                    return;
                }
            }
        },
        onClickOutsideFunction,
        customComponent = null
    }: RequestConfirmationProps) => {
        addBodyClass();

        confirmAlert({
            title: title,
            message: message,
            buttons: [buttons.cancelButton, buttons.confirmButton],
            customUI: ({ onClose }) => {
                return (
                    <div className="react-confirm-alert-body warning-alert">
                        <Lottie
                            animationData={getAnimationIcon('warning')}
                            loop={true}
                            style={{ width: '100px', height: '120px', margin: '0 auto' }}
                        />
                        <h1>{title}</h1>
                        <div className="text-alert">
                            <p>{message}</p>
                        </div>
                        {message_list.length > 0 && (
                            <div className="text-start">
                                {message_list.map((message, index) => (
                                    <li key={index}>{message}</li>
                                ))}
                            </div>
                        )}
                        {customComponent}
                        <div className="react-confirm-alert-button-group">
                            <ButtonGeneral
                                title={buttons.cancelButton.label}
                                onClick={() => {
                                    buttons.cancelButton.onClick();
                                    onClose();
                                }}
                                variant="secondary"
                                size="medium"
                            />
                            <div className="mx-1"></div>
                            <ButtonGeneral
                                title={buttons.confirmButton.label}
                                onClick={() => {
                                    buttons.confirmButton.onClick();
                                    onClose();
                                }}
                                variant="primary"
                                size="medium"
                            />
                        </div>
                    </div>
                );
            },
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            willUnmount: () => {
                removeBodyClass();
            },
            onClickOutside: () => {
                if (onClickOutsideFunction) {
                    onClickOutsideFunction();
                }
                removeBodyClass();
            },
            onkeyPress: () => {
                return;
            },
            onKeypressEscape: () => {
                return;
            },
            overlayClassName: '',
            targetId: targetId
        });
    };

    const alertNotification = ({
        title,
        message,
        confirmButtonText = 'Ok',
        icon = 'success',
        message_list = [],
        useHTML = false
    }: AlertNotificationTypeProps) => {
        addBodyClass();
        confirmAlert({
            title: title,
            message: message,

            customUI: ({ onClose }) => {
                const getAlertClass = (iconType: string) => {
                    switch (iconType) {
                        case 'success': return 'success-alert';
                        case 'error': return 'error-alert';
                        case 'warning': return 'warning-alert';
                        case 'info': return 'info-alert';
                        default: return 'info-alert';
                    }
                };

                return (
                    <div className={`react-confirm-alert-body ${getAlertClass(icon)}`}>
                        <Lottie
                            animationData={getAnimationIcon(icon)}
                            loop={false}
                            style={{ width: '100px', height: '120px', margin: '0 auto' }}
                        />
                        <h1>{title}</h1>
                        <div className="text-alert mb-4">
                            {useHTML ? (
                                <p dangerouslySetInnerHTML={{ __html: message }}></p>
                            ) : (
                                <p>{message}</p>
                            )}
                        </div>
                        {message_list.length > 0 && (
                            <div className="text-start">
                                {message_list.map((message, index) => (
                                    <li key={index}>{message}</li>
                                ))}
                            </div>
                        )}
                        <div className="react-confirm-alert-button-group">
                            <button
                                className={`btn ${icon === 'error' ? 'btn-primary' : 'btn-success'}`}
                                onClick={() => {
                                    onClose();
                                }}
                            >
                                {confirmButtonText}
                            </button>
                        </div>
                    </div>
                );
            },
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            willUnmount: () => {
                removeBodyClass();
            },
            onClickOutside: () => {
                removeBodyClass();
            },
            onkeyPress: () => {
                return;
            },
            onKeypressEscape: () => {
                return;
            },
            overlayClassName: '',
            targetId: targetId
        });
    };

    const requestConfirmationMulti = ({
        title = '¿Estás seguro?',
        message = 'Confirme para continuar',
        buttons = {
            confirmButton: {
                label: 'agregar',
                onClick: () => {
                    return;
                }
            },
            updateButton: {
                label: 'actualizar',
                onClick: () => {
                    return;
                }
            },

            cancelButton: {
                label: 'cancelar',
                onClick: () => {
                    return;
                }
            }
        }
    }: RequestConfirmationProps) => {
        addBodyClass();

        confirmAlert({
            title: title,
            message: message,
            buttons: [buttons.cancelButton, buttons.confirmButton, buttons.updateButton],
            customUI: ({ onClose }) => {
                return (
                    <div className="react-confirm-alert-body">
                        <Lottie
                            animationData={getAnimationIcon('warning')}
                            loop={true}
                            style={{ width: '100px', height: '120px', margin: '0 auto' }}
                        />
                        <h1>{title}</h1>
                        <div className="text-alert">
                            <p>{message}</p>
                        </div>
                        <div className="react-confirm-alert-button-group">
                            <ButtonGeneral
                                title={buttons.confirmButton.label}
                                onClick={() => {
                                    buttons.confirmButton.onClick();
                                    onClose();
                                }}
                                variant="primary"
                                size="medium"
                            />
                            <div className="mx-1"></div>
                            <ButtonGeneral
                                title={buttons.updateButton.label}
                                onClick={() => {
                                    buttons.updateButton.onClick();
                                    onClose();
                                }}
                                variant="outline"
                                size="medium"
                            />
                            <div className="mx-1"></div>
                            <ButtonGeneral
                                title={buttons.cancelButton.label}
                                onClick={() => {
                                    buttons.cancelButton.onClick();
                                    onClose();
                                }}
                                variant="secondary"
                                size="medium"
                            />
                        </div>
                    </div>
                );
            },
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            willUnmount: () => {
                removeBodyClass();
            },
            onClickOutside: () => {
                removeBodyClass();
            },
            onkeyPress: () => {
                return;
            },
            onKeypressEscape: () => {
                return;
            },
            overlayClassName: '',
            targetId: targetId
        });
    };

    const successAlert = ({
        title,
        message,
        confirmButtonText = 'Ok',
        message_list = [],
        useHTML = false
    }: AlertNotificationTypeProps) => {
        alertNotification({
            title: title,
            message: message,
            confirmButtonText: confirmButtonText,
            icon: 'success',
            message_list: message_list,
            useHTML: useHTML
        });
    };

    const infoAlert = ({
        title,
        message,
        confirmButtonText = 'Ok',
        useHTML = false
    }: AlertNotificationTypeProps) => {
        alertNotification({
            title: title,
            message: message,
            confirmButtonText: confirmButtonText,
            icon: 'info',
            useHTML: useHTML
        });
    };

    const warningAlert = ({
        title,
        message,
        confirmButtonText = 'Ok',
        useHTML = false
    }: AlertNotificationTypeProps) => {
        alertNotification({
            title: title,
            message: message,
            confirmButtonText: confirmButtonText,
            icon: 'warning',
            useHTML: useHTML
        });
    };

    const errorAlert = ({
        title,
        message,
        confirmButtonText = 'Ok',
        message_list = [],
        useHTML = false
    }: AlertNotificationTypeProps) => {
        alertNotification({
            title: title,
            message: message,
            confirmButtonText: confirmButtonText,
            icon: 'error',
            message_list: message_list,
            useHTML: useHTML
        });
    };

    return {
        requestConfirmation,
        requestConfirmationMulti,
        successAlert,
        infoAlert,
        warningAlert,
        errorAlert
    };
};

export default useReactConfirmAlert;
